import { toast } from 'react-toastify';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmContext } from '../jsx/common/ConfirmProvider';
import indexedDBService from "./IndexedDBService";

const Error = ({ message }) => (
  <div>
    <h4 className='d-flex align-items-center justify-content-center'>
      <span className='fs-32 mr-2'>{String.fromCodePoint('0x26A0')}</span>
      <span>Опаньки</span>
    </h4>
    <span>{message}</span>
  </div>
);

const Alert = ({ type, header, message }) => (
  <div>
    <h4 className='d-flex align-items-center justify-content-center'>
      {/*<span className='fs-32 mr-2'>{String.fromCodePoint('0x26A0')}</span>*/}
      <span>{header}</span>
    </h4>
    <span>{message}</span>
  </div>
);

export function basicHandleError(errors) {
  console.log('errors', errors);
  let errorMessage = 'Невідома помилка';
  
  if (Array.isArray(errors)) {
    errorMessage = errors.join(', ');
  } else if (typeof errors === 'string') {
    errorMessage = errors;
  } else if (errors?.response?.data?.errors && Array.isArray(errors.response.data.errors)) {
    errorMessage = errors.response.data.errors.join(', ');
  } else if (errors?.message) {
    errorMessage = errors.message;
  }

  toast.error(
    <Error message={errorMessage} />,
    { hideProgressBar: true, autoClose: 5000 }
  );
}

export function useHandleError() {
  const { openConfirm } = useContext(ConfirmContext);
  const { t } = useTranslation();
  return function useHandleError(errors, resp) {
    if (!!resp && resp.status === 401) {
      openConfirm({
        title: t('alertService.goToLoginPage'),
        message: t('alertService.loginRequiredToProceed'),
        danger: false,
        onConfirm: () => {
          const currentPath = window.location.pathname + window.location.search;
          indexedDBService.setSetting('redirectAfterLogin', currentPath);
          window.location.href = '/login';
        },
      });
    } else {
      basicHandleError(errors);
    }
  };
}

export function handleAlert(type, header, message, time) {
  if (type === 'default') {
    toast(<Alert message={message} type={type} header={header} />, { hideProgressBar: true, autoClose: time || 2000 })
  } else {
    toast[type](<Alert message={message} type={type} header={header} />, { hideProgressBar: true, autoClose: time || 1000 })
  }
}